// 新聞頁面 - 互動區塊 按讚分享 留言 評論
'use client';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import NewsCommentInput from './NewsCommentInput'; // 留言輸入
import NewsInteractionFunction from './NewsInteractionFunction'; // 互動功能列

const NewsInteractionWrapper = ({ emojis, newsId }) => {
    const { t } = useTranslation();
    const targetRef = useRef(null);
    return (
        <div>
            {/* 互動功能列 */}
            <NewsInteractionFunction t={t} emojis={emojis} newsId={newsId} targetRef={targetRef} />

            {/* 留言輸入 */}
            <NewsCommentInput t={t} newsId={newsId} targetRef={targetRef} />
        </div>
    );
};

export default NewsInteractionWrapper;
